import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MicrosoftIcon = function MicrosoftIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({
    width: size,
    height: size,
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("title", {
      children: 'Microsoft_logo'
    }), /*#__PURE__*/_jsx("desc", {
      children: 'Created with Sketch.'
    }), /*#__PURE__*/_jsx("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        id: "02.integrations",
        transform: "translate(-448.000000, -274.000000)",
        fillRule: "nonzero",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Microsoft_logo",
          transform: "translate(448.000000, 274.000000)",
          children: [/*#__PURE__*/_jsx("rect", {
            id: "Rectangle-path",
            fillOpacity: "0",
            fill: "#F3F3F3",
            x: "0",
            y: "0",
            width: "24",
            height: "24"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Rectangle-path",
            fill: "#F35325",
            x: "0.929384966",
            y: "0.929384966",
            width: "10.6059226",
            height: "10.6059226"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Rectangle-path",
            fill: "#81BC06",
            x: "12.4646925",
            y: "0.929384966",
            width: "10.6059226",
            height: "10.6059226"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Rectangle-path",
            fill: "#05A6F0",
            x: "0.929384966",
            y: "12.4646925",
            width: "10.6059226",
            height: "10.6059226"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Rectangle-path",
            fill: "#FFBA08",
            x: "12.4646925",
            y: "12.4646925",
            width: "10.6059226",
            height: "10.6059226"
          })]
        })
      })
    })]
  }));
};
export default MicrosoftIcon;